import { IProduct } from "@/interfaces/product";
import Sorting from "../Sorting";
import { Selection } from "@nextui-org/react";
import { useEffect } from "react";
import EOptionKey from "@/constants/option";
import { isEqual } from "lodash";

interface ResultSortingProps {
  products: IProduct[];
  sorting: Selection;
  setSorting: (e: Selection) => void;
  setRenderProducts: (value: IProduct[]) => void;
  renderCount?: number;
}

const ResultSorting: React.FC<ResultSortingProps> = (props) => {
  const { products, sorting, setSorting, setRenderProducts, renderCount } =
    props;

  const priceLowToHigh = (products: IProduct[]) =>
    [...products].sort(
      (a, b) => a.productVariants[0].price - b.productVariants[0].price,
    );

  const priceHighToLow = (products: IProduct[]) =>
    [...products].sort(
      (a, b) => b.productVariants[0].price - a.productVariants[0].price,
    );

  const productRate = (products: IProduct[]) =>
    [...products].sort((a, b) => {
      const maxRatingA = Math.max(
        ...a.productVariants.map((variant) => {
          const averageRating =
            variant.reviews.reduce((sum, review) => sum + review.rate, 0) /
            variant.reviews.length;
          return isNaN(averageRating) ? 0 : averageRating;
        }),
      );

      const maxRatingB = Math.max(
        ...b.productVariants.map((variant) => {
          const averageRating =
            variant.reviews.reduce((sum, review) => sum + review.rate, 0) /
            variant.reviews.length;
          return isNaN(averageRating) ? 0 : averageRating;
        }),
      );

      return maxRatingB - maxRatingA;
    });

  const nameAZ = (products: IProduct[]) =>
    [...products].sort((a, b) =>
      a.name.trim().localeCompare(b.name.trim(), "en", { sensitivity: "base" }),
    );

  const nameZA = (products: IProduct[]) =>
    [...products].sort((a, b) =>
      b.name.trim().localeCompare(a.name.trim(), "en", { sensitivity: "base" }),
    );

  useEffect(() => {
    if (isEqual(Array.from(sorting)[0], EOptionKey.relevance)) {
      setRenderProducts(products);
    }
    if (isEqual(Array.from(sorting)[0], EOptionKey.low)) {
      setRenderProducts(priceLowToHigh(products));
    }
    if (isEqual(Array.from(sorting)[0], EOptionKey.high)) {
      setRenderProducts(priceHighToLow(products));
    }
    if (isEqual(Array.from(sorting)[0], EOptionKey.rate)) {
      setRenderProducts(productRate(products));
    }
    if (isEqual(Array.from(sorting)[0], EOptionKey.nameAZ)) {
      setRenderProducts(nameAZ(products));
    }
    if (isEqual(Array.from(sorting)[0], EOptionKey.nameZA)) {
      setRenderProducts(nameZA(products));
    }
  }, [sorting, products]);

  return (
    <div className="flex text-sm items-center gap-4">
      <div>
        {renderCount !== null && renderCount !== undefined
          ? `${renderCount} ${renderCount > 1 ? `RESULTS` : `RESULT`}`
          : `${products.length} ${products.length > 1 ? `RESULTS` : `RESULT`}`}
      </div>
      <Sorting value={sorting} setValue={setSorting} />
    </div>
  );
};

export default ResultSorting;
